import { gql } from '@apollo/client';

export const DELETE_RESOURCE = gql`
  mutation DeleteResource($input: DeleteByIdInput!) {
    deleteResource(input: $input) {
      success
      message
      messageCode
    }
  }
`;

export interface DeleteResourceInput {
  id: number;
}

export interface DeleteResourceResponse {
  deleteResource: {
    success: boolean;
    message: string;
    messageCode?: string | null;
  };
}

export interface DeleteResourceVariables {
  input: DeleteResourceInput;
}

